import getHtmlParam from '../../utilities/htmlParam';
import {HtmlEscapeUtils} from '../../utilities/HtmlEscapeUtils';

const mp = getHtmlParam('.js-mp .param');
const param = getHtmlParam('.js-param .param');

export class Rating {
  init() {
    const itemRating = document.querySelector('.product-item-title-rating');
    const ratingBox = document.getElementById('add-rating-box');

    if (itemRating) {
      // add rating
      this.loadSingleRatings(param.get('productId'));
      const artTitel = document.getElementById('article-title').textContent;
      const productShortDescription: HTMLElement = document.querySelector('.productShortDescription');

      productShortDescription && (productShortDescription.innerText = artTitel);

      const starsRateable = document.querySelectorAll('.stars-rateable li');
      starsRateable.forEach((star: HTMLInputElement) => {
        const onStar = parseInt(star.dataset.value, 10);
        star.addEventListener('mouseover', () => {
          star.parentElement.querySelectorAll('li.star').forEach((el, index) => {
            if (index < onStar) {
              el.classList.add('hover');
            } else {
              el.classList.remove('hover');
            }
          });
        });

        star.addEventListener('mouseout', () => {
          star.parentElement.querySelectorAll('li.star').forEach((el) => {
            el.classList.remove('hover');
          });
        });

        star.addEventListener('click', () => {
          let ratingValue = '0';
          const stars = star.parentElement.querySelectorAll('li.star');

          for (let i = 0; i < stars.length; i++) {
            stars[i].classList.remove('selected');
          }

          for (let i = 0; i < onStar; i++) {
            stars[i].classList.add('selected');
          }

          if (star.dataset.item === 'price') {
            const lastSelectedStar = document.querySelectorAll('.stars-rateable-price li.selected');
            ratingValue = lastSelectedStar[lastSelectedStar.length - 1] && (lastSelectedStar[lastSelectedStar.length - 1] as HTMLElement).dataset.value;
            (document.querySelector('input#priceValue') as HTMLInputElement).value = ratingValue;
          }
          if (star.dataset.item === 'quality') {
            const lastSelectedStar = document.querySelectorAll('.stars-rateable-quality li.selected');
            ratingValue = lastSelectedStar[lastSelectedStar.length - 1] && (lastSelectedStar[lastSelectedStar.length - 1] as HTMLElement).dataset.value;
            (document.querySelector('input#qualityValue') as HTMLInputElement).value = ratingValue;
          }

          addRating(ratingValue);
        });
      });

    }

    function addRating(ratingValue: string) {
      const priceValue = Number((document.querySelector('input#priceValue') as HTMLInputElement).value);
      const qualityValue = Number((document.querySelector('input#qualityValue') as HTMLInputElement).value);
      const resultValue = Math.round(Number(priceValue + qualityValue) / 2);
      (document.getElementById('resultValue') as HTMLInputElement).value = resultValue.toString();

      document.querySelectorAll('.star01,.star02,.star03,.star04,.star05').forEach(star => star.classList.remove('star-rated'));

      switch (resultValue) {
        case 1:
          document.querySelector('.star01').classList.add('star-rated');
          break;
        case 2:
          document.querySelectorAll('.star01,.star02').forEach(star => star.classList.add('star-rated'));
          break;
        case 3:
          document.querySelectorAll('.star01,.star02,.star03').forEach(star => star.classList.add('star-rated'));
          break;
        case 4:
          document.querySelectorAll('.star01,.star02,.star03,.star04').forEach(star => star.classList.add('star-rated'));
          break;
        case 5:
          document.querySelectorAll('.star01,.star02,.star03,.star04,.star05').forEach(star => star.classList.add('star-rated'));
          break;
      }

      const overallRatingBox = document.querySelector('.overall-rating-box') as HTMLElement;
      overallRatingBox && (overallRatingBox.style.opacity = '1');
    }

    // submit rating
    const inputRatingPseudonym = document.getElementById('input-rating-pseudonym');
    const inputRatingTitle = document.getElementById('input-rating-title');
    const inputRatingRezension = document.getElementById('input-rating-rezension');
    inputRatingPseudonym && inputRatingPseudonym.addEventListener('change', () => {
      const errors = document.querySelectorAll('#input-rating-pseudonym-error');
      errors && (errors.forEach((error: HTMLElement) => error.style.display = 'none'));
    });
    inputRatingTitle && inputRatingTitle.addEventListener('change', () => {
      const errors = document.querySelectorAll('#input-rating-titel-error');
      errors && (errors.forEach((error: HTMLElement) => error.style.display = 'none'));
    });
    inputRatingRezension && inputRatingRezension.addEventListener('change', () => {
      const errors = document.querySelectorAll('#input-rating-rezension-error');
      errors && (errors.forEach((error: HTMLElement) => error.style.display = 'none'));
    });

    const addRatingForm = document.getElementById('add-rating-form') as HTMLFormElement;

    addRatingForm && addRatingForm.addEventListener('submit', () => {
      let formerror = false;
      event.preventDefault();

      const errors = document.querySelectorAll('#input-rating-pseudonym-error, #input-rating-titel-error, #input-rating-rezension-error');
      errors && (errors.forEach((error: HTMLElement) => error.style.display = 'none'));
      const ratingSubmitError = document.querySelectorAll('.ratingSubmitError');
      ratingSubmitError.forEach(error => {
        error.classList.remove('ratingSubmitError');
      });

      const quality = document.getElementById('qualityValue') as HTMLInputElement;
      const price = document.getElementById('priceValue') as HTMLInputElement;
      const name = document.getElementById('input-rating-pseudonym') as HTMLInputElement;
      const title = document.getElementById('input-rating-title') as HTMLInputElement;
      const text = document.getElementById('input-rating-rezension') as HTMLInputElement;

      const qualityValue = quality && quality.value;
      const priceValue = price && price.value;
      const nameValue = name && name.value;
      const titleValue = title && title.value;
      const textValue = text && text.value;

      if (nameValue.length < 1) {
        formerror = true;
        document.querySelectorAll('#input-rating-pseudonym-error').forEach((error: HTMLElement) => error.style.display = 'block');
      }
      if (titleValue.length < 1) {
        formerror = true;
        document.querySelectorAll('#input-rating-titel-error').forEach((error: HTMLElement) => error.style.display = 'block');
      }
      if (textValue.length < 1) {
        formerror = true;
        document.querySelectorAll('#input-rating-rezension-error').forEach((error: HTMLElement) => error.style.display = 'block');
      }

      if (qualityValue !== '0' && priceValue !== '0') {
        if (formerror === false) {
          const rawData: any = new FormData(addRatingForm);
          const form_data = new URLSearchParams(rawData).toString();
          addRatingForm.reset();

          window.fetch('/rating/public/save', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: form_data,
          })
          .then(response => response)
          .then(data => {
            if(data.ok) {
              const contentsToHideArray = Array.from(document.querySelectorAll('.add-form-content'));
              contentsToHideArray.forEach(contentToHide => {
                (<HTMLElement>contentToHide).style.display = 'none';
              })
              document.getElementById('add-rating-box-thanks').style.display = 'block';
              const addRating = document.getElementById('add-rating');
              addRating.parentNode.removeChild(addRating);
              (document.querySelector('.rating-in-progress') as HTMLElement).style.display = 'none';
              document.getElementById('rating').scrollIntoView({ behavior: 'smooth', block: 'center'});
            }
          });
        }
      } else {
        if (qualityValue === '0') {
          document.querySelectorAll('.addRatingHeadline-quality').forEach(el => el.classList.add('ratingSubmitError'));
        }
        if (priceValue === '0') {
          document.querySelectorAll('.addRatingHeadline-price').forEach(el => el.classList.add('ratingSubmitError'));
        }
      }
    });

    // rating bars
    let starssummery = 0;
    const ratingPercent = document.querySelectorAll('.rating-percent');
    for (let i = 0; i < ratingPercent.length; ++i) {
      starssummery += parseInt((ratingPercent[i] as HTMLElement).dataset.countStars);
    }
    ratingPercent.forEach((rate: HTMLElement) => {
      const calc = parseInt(rate.dataset.countStars) * 100 / starssummery;
      rate.innerHTML = calc.toFixed(0) + "%";
    });

    // slide and scroll to rating
    const jumpToRating = document.querySelectorAll('.add-rating');
    jumpToRating.forEach((jump) => {
      jump.addEventListener('click', () => {
        const ratingWrapper = document.getElementById('rating-wrapper');

        if (ratingBox && ratingBox.offsetParent === null) {
          ratingBox.style.display = 'block';
        } else {
          ratingWrapper && ratingWrapper.classList.add('add-new-rating-flash');
        }
        scrolltoRating();
      });
    });

    function scrolltoRating() {
      const rating = document.querySelector('.pda-rating-list');
      const headerHeight = document.querySelector("header")?.getBoundingClientRect()?.height ?? 0;
      if (!rating) return console.warn("rating scroll target not found");

      const scrollTarget = rating.getBoundingClientRect().top + window.scrollY - headerHeight;
      window.scroll({ top: scrollTarget, behavior: 'smooth' });
    }
   
    function getQueryString() {
      let key: any = false, res: any = {}, itm: any = null;
      const qs = location.search.substring(1);
      if (arguments.length > 0 && arguments[0].length > 1)
        key = arguments[0];
      var pattern = /([^&=]+)=([^&]*)/g;
      while (itm = pattern.exec(qs)) {
        if (key !== false && decodeURIComponent(itm[1]) === key)
          return decodeURIComponent(itm[2]);
        else if (key === false)
         res[decodeURIComponent(itm[1])] = decodeURIComponent(itm[2]);
      }

      return key === false ? res : null;
    }

    const parameter = getQueryString();

    if (typeof parameter.jumpto !== 'undefined' && parameter.jumpto === 'rating') {
        scrolltoRating();
        const mainAddRating = document.getElementById('add-rating');
        ratingBox && (ratingBox.style.display = 'block'); // slidedown 300
        mainAddRating && (mainAddRating.style.display = 'none');
    }

    const ratingClose = document.querySelector('.rating-close');

    ratingClose && ratingClose.addEventListener('click', () => {
      ratingBox && (ratingBox.style.display = 'none'); // slideup 300
      const starsLi = document.querySelectorAll('rating-stars li');
      const ratingFields = document.querySelectorAll('#input-rating-pseudonym, #input-rating-title, #input-rating-rezension');

      let ratingInUse = false;

      starsLi.forEach(star => {
        if (star.classList.contains('selected')) {
          ratingInUse = true;
        }
      });

      ratingFields.forEach((field: HTMLInputElement) => {
        if (field.value.length) {
          ratingInUse = true;
        }
      });

      if (ratingInUse) {
        const inProgress = document.querySelector('.rating-in-progress') as HTMLElement;
        if (inProgress) {
          inProgress.classList.add('show-info-banner');
          inProgress.style.display = 'inline';
        }
      }
    });


    // Rating Item

    // disable on small devices!
    const animationElements = document.querySelectorAll('.vp-animation');

    // disable triggering on small devices
    const isMobile = window.matchMedia('only screen and (max-width: 768px)');
    if (isMobile.matches) {
      animationElements.forEach(el => el.classList.remove('vp-animation'));
    }

    function checkIfInView() {
      const windowHeight = parseFloat(getComputedStyle(document.body, null).height.replace('px', ''));
      const windowTopPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      const windowBottomPosition = (windowTopPosition + windowHeight);

      animationElements.forEach((element: HTMLElement) => {
        const elementHeight = element.clientHeight;
        const elementTopPosition = element.getBoundingClientRect().top;
        const elementBottomPosition = (elementTopPosition + elementHeight);

        // check to see if this current container is within viewport
        if ((elementBottomPosition >= windowTopPosition) &&
          (elementTopPosition <= windowBottomPosition)) {
          element.classList.add('in-view');
        }
      });
    }

    window.addEventListener('scroll', checkIfInView);
    window.addEventListener('resize', checkIfInView);

    checkIfInView();

    const toggleRating = document.querySelectorAll('.toggle-rating');
    this.setFilter(toggleRating);

    const resetFilter = document.querySelector('.toggle-reset-rating-filter');
    resetFilter && resetFilter.addEventListener('click', (event) => {
      event.preventDefault();
      this.resetFilter();
    });
  }

  setFilter(toggleRating: NodeListOf<Element>) {
    toggleRating.forEach((toggle: HTMLElement) => {
      toggle.addEventListener('click', (event) => this.filterItemClickHandler(event, toggleRating));
    });
  }

  filterItemClickHandler(event: Event, toggleRating: NodeListOf<Element>) {
    const target = event.target as HTMLElement;
    const rootElement = target.closest("tr");
    const rating = rootElement.getAttribute('data-rating');
    if (rating) this.updateFilterView(Number(rating));
  }

  updateFilterView(rating: number) {
    const ratingEntries: NodeListOf<HTMLElement> = document.querySelectorAll('.add-rating-user-item .rating-entry');

    for (const filterItem of ratingEntries) {

      const filterItemRating = Math.floor(Number(filterItem.getAttribute("data-rating")));
      if (!filterItemRating) return console.warn("no rating found")

      if (filterItemRating === rating) {
        filterItem.classList.remove("hidden");
      } else {
        filterItem.classList.add("hidden");
      }
    }

    Array.from(ratingEntries).some( item => item.classList.contains("hidden")) ? this.setFilterButton("shown") : this.setFilterButton("hidden");
  }

  sanitizeHtmlText(source: string): string {
    let unescaped = HtmlEscapeUtils.unescapeHtmlRepeatedly(source);
    let escaped = HtmlEscapeUtils.escapeHtml(unescaped);
    let output = HtmlEscapeUtils.replaceLineBreaks(escaped, '<br/>');
    return output;
  }

  resetFilter() {
    const ratingEntries: NodeListOf<HTMLElement> = document.querySelectorAll('.add-rating-user-item .rating-entry');
    if (ratingEntries.length === 0) console.warn("no rating found to reset");
    ratingEntries.forEach(item => item.classList.remove("hidden"));
    this.setFilterButton("hidden");
  }

  setFilterButton(status: 'hidden' | 'shown') {
    const button = document.querySelector('.rating-filter-info');
    if (!button) return console.warn("filter button not found");
    status === 'hidden' ? button.classList.add("hidden") : button.classList.remove("hidden");
  }

  loadSingleRatings(pid: string) {
    fetch('/rating/public/view/translated/' + param.get('tenant') + '/' + param.get('clientLocale') + '/' + pid)
      .then(res => res.json())
      .then((data) => {
        let countItem = 0;
        let setStarsProduct: any = new Number('');
        let setStarsPrice: any = new Number('');

        let starSingleResult: any = new Number();

        let purchaseNotVerifiedMP:string = mp.get('review_not_verified');
        let purchaseNotVerifiedMessage:string = '<span class="hoverTooltip"><i class="uil uil-info-circle"></i><span>' + purchaseNotVerifiedMP +'</span></span>';

        const overallQualityInner = document.querySelectorAll('.overall-quality-inner');
        const overallPriceInner = document.querySelectorAll('.overall-price-inner');

        data.forEach((obj: any, i: number) => {
          countItem++;
          starSingleResult = obj['starsAverage'] ? new Number(obj['starsAverage']) : this.roundToNearestHalf((obj.starsPrice + obj.starsProduct) / 2) ;

          const ratingBorderstarsProduct: any = new Number(obj['starsProduct'] * 100);
          const ratingBorderstarsPrice: any = new Number(obj['starsPrice'] * 100);

          setStarsPrice = setStarsPrice + new Number(obj['starsPrice']);
          setStarsProduct = setStarsProduct + new Number(obj['starsProduct']);

          overallQualityInner.forEach((quality: HTMLElement) => quality.style.width = ratingBorderstarsProduct / 5 + "%");
          overallPriceInner.forEach((price: HTMLElement) => price.style.width = ratingBorderstarsPrice / 5 + "%");

          const objAnswer = obj['answer'];
          const objText = obj['text'];
          const objTitle = obj['title'];

          const ratingAnswer = objAnswer !== null ? this.sanitizeHtmlText(objAnswer.trim()) : '';
          const ratingText = objText !== null ? this.sanitizeHtmlText(objText.trim()) : '';
          const ratingTitle = objTitle !== null ? this.sanitizeHtmlText(objTitle.trim()) : '';

          let translationHint = '';
          if (obj['hint'] !== null) {
            translationHint = '<p class="rating-translation-hint mb-2">' + obj['hint'] + '</p>';
          }

          let ratingAnswerHtml = '';
          if (typeof ratingAnswer !== 'undefined' && ratingAnswer !== '' && ratingAnswer !== 'null' && ratingAnswer !== null) {
            ratingAnswerHtml = '<div class="rating-answer mb-3"><div class="rating-avatar-bg-wrapper"><i class="uil uil-users-alt rating-avatar-bg-ssh"></i></div><div class="rating-answer-wrapper"><div class="rating-answer-label">' + mp.get('rating_answer') + '</div><div class="rating-answer-text">' + ratingAnswer + '</div></div></div>';
          }

          let userName = obj['userName'];
          if (userName === "Schäfer Shop Kunde") {
            userName = mp.get('rating_username');
          }

          const addRatingContent = ''
            + '<div class="rating-entry pb-3" data-rating="' + starSingleResult + '">'
            + '<div class="row pt-3 pb-2">'
            + '<div class="col-md-9 col-xs-12 fc-grey mb-3 p-0"><span><i class="uil uil-user rating-avatar-bg"></i>' + userName + '<span> ' + mp.get('rating_date') + ' </span>' + this.formatedDate(obj['createdAt']) + purchaseNotVerifiedMessage + '</span></div>'
            + '<div class="col-md-12 p-0 rating-details">'
            + '<ul class="product-item-title-rating-review">'
            + '<li class="ratingStar">'
            + '<span class="stars-' + countItem + '">' + countItem + '</span>'
            + '</li>'
            + '</ul>'
            + '<i class="uil uil-angle-down" style="cursor:pointer;"></i>'
            + '<div class="product-item-rating-title fs-medium fw-bold">' + ratingTitle + '</div>'
            + '</div>'
            + '</div>'
            + '<div class="row" style="display:none;">'
            + '<div class="col-md-4 p-0 mb-3">'
            + '<div class="small fs-small fc-black mb-3">' + mp.get('rating_quality')
            + '<div><div class="tooltip-bar-outer"><div class="overall-inner" style="width: ' + ratingBorderstarsProduct / 5 + '%;"></div></div></div></div>'
            + '<div class="small fs-small fc-black">' + mp.get('rating_balance')
            + '<div><div class="tooltip-bar-outer"><div class="overall-inner" style="width: ' + ratingBorderstarsPrice / 5 + '%;"></div></div></div></div>'
            + '</div>'
            + '</div>'
            + '<div class="row rating-item-border-bottom" style="padding-top: 0; margin-bottom: 10px;">'
            + '<div><p class="user-rating-text mb-2">' + ratingText + '</p>' + translationHint
            + ratingAnswerHtml
            + '</div>'
            + '</div>'
            + '</div>'
          ;

          const addRatingUserItem = document.querySelector('.add-rating-user-item');
          addRatingUserItem && (addRatingUserItem.innerHTML += addRatingContent);

          const rating = starSingleResult;
          const numStars = 5;
          const fullStar = new Array(Math.floor(rating + 1)).join('<i class="uil uil-star-active star-rated"></i>');
          const halfStar = ((rating % 1) !== 0) ? '<i class="uil uil-star-half-alt-active star-rated"></i>' : '';
          const noStar = new Array(Math.floor(numStars + 1 - rating)).join('<i class="uil uil-star star-rated"></i>');
          const selectedStar = document.querySelector('.stars-' + countItem);
          selectedStar && (selectedStar.innerHTML = fullStar + halfStar + noStar);
        });

        // set review count
        const countRating = document.querySelector(".countRating" + pid);
        const countRatingNumber = document.querySelector(".countRatingNumber" + pid);
        countRating && (countRating.textContent = "(" + countItem + ")");
        countRatingNumber && (countRatingNumber.textContent = countItem.toString());

        setStarsProduct = new Number(setStarsProduct / countItem);
        setStarsPrice = new Number(setStarsPrice / countItem);

        setStarsProduct = setStarsProduct * 100 / 5;
        setStarsPrice = setStarsPrice * 100 / 5;
        if (countItem > 1) {
          overallQualityInner.forEach((quality: HTMLElement) => quality.style.width = setStarsProduct + "%");
          overallPriceInner.forEach((price: HTMLElement) => price.style.width = setStarsPrice + "%");
        }

        const ratingDetails = document.querySelectorAll('.rating-details');

        ratingDetails.forEach(rating => {
          rating.addEventListener('click', () => {
            const iconDown = rating.querySelector('.uil-angle-down');
            const iconUp = rating.querySelector('.uil-angle-up');
            if(iconDown) {
              iconDown.classList.remove('uil-angle-down');
              iconDown.classList.add('uil-angle-up');
            }
            if(iconUp) {
              iconUp.classList.remove('uil-angle-up');
              iconUp.classList.add('uil-angle-down');
            }
            const details = (rating.parentElement.nextElementSibling as HTMLElement);
            if (details.offsetParent === null) {
              details.style.display = 'block'; //slidetoggle fast
            } else {
              details.style.display = 'none';
            }
          });
        });

      });
  }

  roundToNearestHalf(value: number): number {
    return Math.min(5, Math.max(0, Math.round(value * 2) / 2));
  }

  formatedDate(date: string): string {
    return new Date(date).toLocaleDateString(navigator.language);
  }
}
